import {
  GlobalStyles,
  Grid,
  Link,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import React, { useEffect, useState } from 'react'

export const HEADER_HEIGHT = 64

const BaseLayout = ({
  showHeader = true,
  showSidebar = true,
  header,
  sidebar,
  children,
  sidebarProps,
  layoutProps,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [mobileOpen, setMobileOpen] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(false)

  useEffect(() => {
    if (!isMobile) setMobileOpen(false)
  }, [isMobile])

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const onCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }

  const modifiedHeader =
    (showHeader || isMobile) && header
      ? React.cloneElement(header, {
          onMenuToggle: handleDrawerToggle,
          isCollapsed,
        })
      : null

  const modifiedSidebar =
    showSidebar && sidebar
      ? React.cloneElement(sidebar, {
          mobileOpen,
          onDrawerToggle: handleDrawerToggle,
          onCollapse,
        })
      : null

  return (
    <>
      <Link
        href="#main-content"
        aria-label="skip to main content"
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: (theme) => theme.zIndex.tooltip + 100,
          p: 1,
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          transform: 'translateY(-100%)',
          '&:focus': { transform: 'translateY(0)' },
        }}
      >
        Skip to main content
      </Link>
      <GlobalStyles
        styles={{
          body: {
            backgroundColor: `${theme.palette.menu.background.default} !important`,
          },
        }}
      />
      <Grid container size={12} width={1} p={0} my={0}>
        {modifiedHeader}
        {modifiedSidebar}
        <main
          id="main-content"
          tabIndex={-1}
          style={{
            width:
              showSidebar && !isMobile
                ? `calc(100% - ${isCollapsed ? sidebarProps.collapsedWidth : sidebarProps.width}px)`
                : '100%',
            height: showHeader && `calc(100vh - ${HEADER_HEIGHT}px)`,
            marginTop: showHeader || isMobile ? `${HEADER_HEIGHT}px` : 0,
            marginLeft:
              showSidebar && !isMobile
                ? isCollapsed
                  ? sidebarProps.collapsedWidth
                  : sidebarProps.width
                : 0,
            transition: theme.transitions.create(['margin', 'width'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.standard,
            }),
            backgroundColor: theme.palette.background.paper,
            borderRadius:
              !isMobile && `${theme.shape.borderRadius}px 0px 0px 0px`,
            ...layoutProps,
            overflowY: 'auto',
          }}
        >
          <div
            style={{
              borderRadius: `${theme.shape.borderRadius}px 0px 0px 0px`,
              backgroundColor: theme.palette.background.default,
              minHeight: `calc(100dvh - ${HEADER_HEIGHT}px)`,
              width: '100%',
            }}
          >
            <div
              style={{
                maxWidth: theme.breakpoints.values.xl,
                padding: theme.spacing(2),
                margin: `0px auto`,
              }}
            >
              {children}
            </div>
          </div>
        </main>
      </Grid>
    </>
  )
}

export default BaseLayout
